exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.header[data-v-8a13d6be] {\n  background: #fff;\n}\n.content.grey[data-v-8a13d6be] {\n  background-color: rgb(255, 249, 249);\n}\n.text-gray[data-v-8a13d6be] {\n  font-size: 18px;\n}\n.modal[data-v-8a13d6be] {\n    font-size: 16px;\n}\n.col1[data-v-8a13d6be] {\n  font-family: 'TTCommons-Light';\n}\n.col1.bold[data-v-8a13d6be] {\n  font-family: 'TTCommons-Medium';\n  color: #1d1d1d;\n  margin-bottom: 3px;\n}\n", ""]);

// exports
